module.exports = __webpack_public_path__ + "img/perguntas.1040dc49.png";